module.exports = __webpack_public_path__ + "img/66.0e0526fc.jpg";